import { useCallback, useState } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { usePropertyValue } from '../hooks/usePropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';
import { formatRawPhoneNumber } from '../../input/phone/utils/phoneNumberUtils';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import { useCallingMessage } from '../hooks/useCallingMessage';
import { trackFormattedPropertyPhoneClick } from '../../utils/usageTrackingUtils';
import { stopPropagationHandler } from 'foundations-components/transitional/utils/DomEvents';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPropertyPhone = props => {
  useComponentMountMetric('FormattedPropertyPhone');
  const [isLoading, setIsLoading] = useState(false);
  const propertyValue = usePropertyValue();
  const {
    placeholder
  } = props;
  const {
    canSendMessage,
    sendMessage
  } = useCallingMessage();
  const initiateCall = useCallback(() => {
    if (isLoading || !canSendMessage) {
      return;
    }
    setIsLoading(true);
    sendMessage().catch(() => {}).finally(() => {
      setIsLoading(false);
    });
  }, [isLoading, canSendMessage, sendMessage]);
  const handlePhoneClick = useCallback(event => {
    stopPropagationHandler(event);
    trackFormattedPropertyPhoneClick();
    initiateCall();
  }, [initiateCall]);
  if (canSendMessage && propertyValue) {
    return /*#__PURE__*/_jsx(Link, {
      onClick: handlePhoneClick,
      role: "button",
      children: /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
        children: formatRawPhoneNumber(propertyValue)
      }))
    });
  }
  return /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
    children: propertyValue ? formatRawPhoneNumber(propertyValue) : placeholder
  }));
};
FormattedPropertyPhone.displayName = 'FormattedPropertyPhone';
export default FormattedPropertyPhone;